import { useEffect, useState } from 'react';
import {
  onSave,
  refinePayload,
  fieldValidation,
  useNotification,
  getDialogHeading,
} from 'utils/commonUtils';
import * as yup from 'yup';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { PaperProps, cancelSessionSuccess } from 'constants';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { ConfirmSubmitButton } from '../BookNewSessionTabV2/bookNewSessionTabUtils';
import { putCancelTutoringV2Session } from '../BookNewSessionTabV2/services/bookNewSessionTabV2Api';

const schema = yup.object().shape({
  reasonForCancel: fieldValidation(4000),
});

const CancelBookedSessionV2Dialog = ({
  open,
  setOpen,
  deleteSessionInfo,
  fetchBookedSessions,
}) => {
  const dispatch = useDispatch();
  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const { sessionId } = deleteSessionInfo;

  const [loadingButton, setLoadingButton] = useState(false);

  const defaultValue = {
    reasonForCancel: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.reasonForCancel]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const payload = {
      statusNote: data?.reasonForCancel,
    };
    onSave(
      cancelSessionSuccess,
      false,
      () => {},
      putCancelTutoringV2Session,
      refinePayload(payload),
      sessionId,
      fetchBookedSessions,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton,
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={PaperProps}>
        {getDialogHeading('Cancel Session', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              rows={2}
              multiline
              type="text"
              control={control}
              label="Cancel Reason"
              name="reasonForCancel"
              errors={!!errors.reasonForCancel}
              helperText={errors?.reasonForCancel?.message}
            />
          </Grid>
          <Grid item xs={12} justifyItems="right">
            <ConfirmSubmitButton
              isBooked={true}
              onSubmit={onSubmit}
              loading={loadingButton}
              handleSubmit={handleSubmit}
            />
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default CancelBookedSessionV2Dialog;
